export default __webpack_public_path__ + "3bc20a97e2023f913c1793a69ad1592b.png";